$(document).ready(function(){

   $('.nav-btn').click(function(){
      console.log('open navigation');
      $(this).toggleClass('open');
      $('.header-navigation').toggleClass('is-visible');
   });

   /* ---------------------------------------------------------------
    * Sticky navigation (desktop only, 992px+)
    *
    * The sticky state swaps position: absolute -> fixed, which no
    * browser can tween, so the entrance is a CSS keyframe that drops
    * the bar in from above the viewport.
    *
    * The exit is handled by geometry rather than animation. The bar
    * sits at top: 140px in flow and top: 30px when fixed, so the two
    * positions land on the same pixel once the page is scrolled
    * 140 - 30 = 110px. Releasing exactly there makes the swap
    * invisible -- animating out instead reads as a bug, because the
    * bar slides away and then the in-flow bar re-enters separately.
    * --------------------------------------------------------------- */
   var $nav       = $('.header-navigation'),
       desktop    = window.matchMedia('(min-width: 992px)'),
       NAV_TOP    = 140,  // .header-navigation top, in flow (navigation.scss)
       STUCK_TOP  = 30,   // .header-navigation.sticky top    (navigation.scss)
       STICK_AT   = 250,  // scroll depth that pins the bar
       RELEASE_AT = NAV_TOP - STUCK_TOP, // 110: the seamless handoff point
       isStuck    = false,
       ticking    = false;

   function setStuck(next){
      if(next === isStuck) return;
      isStuck = next;
      $nav.toggleClass('sticky', next);
   }

   function update(){
      ticking = false;

      if(!desktop.matches){
         setStuck(false);
         return;
      }

      var top = $(window).scrollTop();
      if(top > STICK_AT){
         setStuck(true);
      } else if(top < RELEASE_AT){
         setStuck(false);
      }
   }

   $(window).on('scroll', function(){
      // Coalesce scroll events to one class check per frame.
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
   });

   // matchMedia change fires when crossing the breakpoint on resize.
   if(desktop.addEventListener){
      desktop.addEventListener('change', update);
   } else if(desktop.addListener){
      desktop.addListener(update);
   }

   update(); // handle a page loaded already scrolled down

   $('.flip-card').click(function(){
      $('.flip-card').not(this).find('.flip-container').removeClass('flipped');
      $(this).find('.flip-container').toggleClass('flipped');
   });

});


const communitySwiper = new Swiper('.gallery-swiper', {
   direction: 'horizontal',
   loop: false,

   slidesPerView: 1,
   spaceBetween: 0,

   breakpoints: {
      992: {
         slidesPerView: 3,
         spaceBetween: 10,
      }
   },
   navigation: {
      nextEl: '.gallery-next',
      prevEl: '.gallery-prev',
   },
});